import { usePocQuery } from 'core/custom-hooks/use-poc-query.hook';
import { useTranslation } from 'core/i18n/i18n';
import { QUERY_KEYS } from 'core/query-client/query-keys.constants';
import { showErrorNotification } from 'core/utils/notification-service';
import { useEffect } from 'react';
import { CustomAlarmDefinitionTrackableEvent } from 'modules/settings/pods/settings-devices/settings-devices-configuration/domain/custom-alarm-definition.vm';
import { getRegisteredEvents } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-form/service/custom-alarm-form.service';

interface UseRegisteredEventsFetcherProps {
    deviceTypeId?: string;
}

export const useRegisteredEventsFetcher = ({ deviceTypeId }: UseRegisteredEventsFetcherProps) => {
    const { t } = useTranslation();

    const {
        data: registeredEvents = [],
        isFetching: isLoadingEvents,
        isError,
    } = usePocQuery<CustomAlarmDefinitionTrackableEvent[]>({
        queryKey: QUERY_KEYS.REGISTERED_EVENTS_DEVICE_TYPE_ID(deviceTypeId ?? ''),
        queryFn: () => getRegisteredEvents(deviceTypeId ?? ''),
        enabled: Boolean(deviceTypeId),
    });

    useEffect(() => {
        if (isError) {
            showErrorNotification(t('settings.devices.custom-alarms.notifications.events.error'));
        }
    }, [isError, t]);

    return {
        registeredEvents,
        isLoadingEvents,
    };
};
